import React from 'react'
import PropTypes from 'prop-types'

import Font from '@cred/react-font'

import pig from '../images/pig.png'
import SavingsContent from './savings-content'
import styles from './styles.module.scss'

export const EmptyState = () => (
  <>
    <Font color="lighter" weight="semiBold" type="bodySmall" className="align-center mb-8">
      See your potential savings
    </Font>
    <img className={styles.pig} src={pig} alt="piggy bank" />
  </>
)

const SavingsDisplay = ({ savings }) => (
  <div className={styles.savingsDisplayRoot}>
    {savings ? <SavingsContent savings={savings} /> : <EmptyState />}
  </div>
)

SavingsDisplay.propTypes = {
  savings: PropTypes.number,
}

export default SavingsDisplay
